var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477,
    height: 246,
    viewBox: "0 0 477 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_19_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.742 84.029C186.242 81.529 179.242 62.5291 129.742 49.5291C84.0838 37.5381 68.2036 68.9376 62.8745 75.0611C55.3303 73.3837 38.2419 84.3291 30.2419 141.529C20.2419 213.029 73.2419 225.529 95.7419 215.029C118.242 204.529 118.742 218.029 159.242 215.029C199.742 212.029 233.742 224.029 294.242 225.529C342.642 226.729 392.075 214.696 410.742 208.529C425.075 158.362 452.442 58.0291 447.242 58.0291C440.742 58.0291 409.742 97.5291 389.242 105.029C368.742 112.529 367.742 91.0291 366.742 84.029C365.742 77.029 357.742 39.029 304.742 24.029C251.742 9.02904 299.742 38.029 281.742 76.0291C263.742 114.029 259.242 86.529 222.742 84.029Z",
    fill: "url(#paint0_linear_19_434)",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19_434",
    x: 0,
    y: -9,
    width: 476.891,
    height: 263.613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5,
    result: "effect1_foregroundBlur_19_434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_434",
    x1: 238.445,
    y1: 20,
    x2: 238.445,
    y2: 225.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F69FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBottom);
export default __webpack_public_path__ + "static/media/right-bottom.991c3c23a7fbebcd45292d2b30a673e6.svg";
export { ForwardRef as ReactComponent };